<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <v-text-field
          :label="$t('identifier')"
          hint="Por ejemplo: 1, A1"
          v-model="table.name"
          :rules="$rule('required|max128')"
          persistent-hint
          outlined
          dense
        ></v-text-field>
        <v-text-field
          :label="$t('description')"
          class="mb-3"
          v-model="table.description"
          :rules="$rule('max255')"
          :persistent-hint="true"
          :hint="$t('table.description.formHint')"
          outlined
          dense
        ></v-text-field>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="cancel" :disabled="loading">{{ $t('cancel') }}</v-btn>
      <v-btn
        color="primary"
        :disabled="!valid"
        @click="save"
        :loading="loading"
        >{{ $t('save') }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { ITable } from '../../interfaces/ITable';
  import TablesService from '../../api/services/tables.service';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';

  @Component
  export default class NewTableModal extends Vue {
    @Prop() table: ITable;
    loading = false;
    tablesService = new TablesService();
    title = '';
    valid = false;

    mounted() {
      this.title = !this.table.id
        ? this.$tc('table.new')
        : this.$t('table.editing', { name: this.table.name }).toString();
    }

    async save() {
      this.loading = true;
      try {
        let table = !this.table.id
          ? await this.tablesService.create(this.table)
          : await this.tablesService.update(this.table);
        vueData.addAlert(this.$tc('table.saved'), AlertType.Success);
        if (!this.table.id)
          this.$gtag.event('create', { event_category: 'table' });
        this.$parent.$emit('saved', table);
        this.$emit('close');
      } catch (e) {
        console.error(e);
        vueData.serverError(e, this.$tc('table.errorSaving'));
      } finally {
        this.loading = false;
      }
    }

    cancel() {
      this.$emit('close');
    }
  }
</script>
